import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-1 md:col-span-2">
            <img src="https://i.postimg.cc/zGWWzkp3/logohce-Converted.png" alt="Hill Ear Care" className="h-12 w-auto mb-6 brightness-0 invert opacity-90" />
            <p className="text-gray-400 text-sm max-w-sm mb-6">
              Professional, safe, and effective ear wax removal services. Restoring your hearing clarity with care in Dudley and Wolverhampton.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-rose-gold transition-colors">
                <SafeIcon icon={FiIcons.FiFacebook} className="text-white" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-rose-gold transition-colors">
                <SafeIcon icon={FiIcons.FiInstagram} className="text-white" />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="#pricing" className="hover:text-rose-gold transition-colors">Pricing</a></li>
              <li><a href="#gallery" className="hover:text-rose-gold transition-colors">Gallery</a></li>
              <li><a href="#reviews" className="hover:text-rose-gold transition-colors">Client Reviews</a></li>
              <li><a href="#faq" className="hover:text-rose-gold transition-colors">FAQ</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Our Clinic</h4>
            <ul className="space-y-4 text-gray-400 text-sm">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiIcons.FiMapPin} className="text-rose-gold mt-1 flex-shrink-0" />
                <span>Bailey’s Hair & Beauty,<br />118 The Straits, Dudley DY3 3BA</span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiIcons.FiMail} className="text-rose-gold flex-shrink-0" />
                <a href="mailto:hillearcare@gmail.com" className="hover:text-white">hillearcare@gmail.com</a>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiIcons.FiPhone} className="text-rose-gold flex-shrink-0" />
                <a href="tel:07960998464" className="hover:text-white">07960 998464</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500 gap-4">
          <p>&copy; 2026 Hill Ear Care LTD. All rights reserved.</p>
          <div className="flex gap-4">
            <p>Company Number: 16976554</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;